module.exports = __webpack_public_path__ + "img/titleid.a5bf5f31.png";